import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    const [show, setShow] = useState(false);

    useEffect(() => {
        if (value === index) setShow(true);
        else setShow(false);
    }, [value]);

    return (
        <div
            role="tabpanel"
            // hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
            style={{
                backgroundColor: '#ebf4fa',
                opacity: 0,
                opacity: show ? 1 : 0,
            }}
        >
            <Box sx={{ p: 3 }}>{children}</Box>
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

export default TabPanel;
